import * as actions from '../services'
import * as types from './mutations-types'
import { addFlash } from 'src/app/components/shareds/flash/vuex/mutations-types'
import { t } from 'src/utils/form'
import { setPagination } from 'src/app/components/shareds/pagination/vuex/mutations-types'

export const loadCustomers = (context, payload) => {
  return actions.getCustomers(payload)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(types.setCustomers, response.data.customers)
      context.commit(setPagination, response.data.meta)
    }
    return response
  })
}

export const loadCustomer = (context, payload) => {
  return actions.getCustomer(payload)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(types.setCustomer, response.data.customer)
    } else {
      context.commit(addFlash, { message: t(context, 'customers.alert.not_found'), type: 'ls-alert-danger' })
    }
    return response
  })
}

export const inactiveCustomer = (context, payload) => {
  return actions.destroyCustomer(payload.id)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(addFlash, { message: t(context, 'customers.alert.inactivated'), type: 'ls-alert-success' })
      if (typeof payload.index === 'undefined') {
        context.commit(types.setCustomer, response.data.customer)
      } else {
        context.commit(types.setCustomerActive, { 'index': payload.index, 'active': response.data.customer.status })
      }
    } else {
      context.commit(addFlash, { message: t(context, 'customers.alert.not_found'), type: 'ls-alert-danger' })
    }
    return response
  })
}



// WEBPACK FOOTER //
// ./src/app/pages/customers/vuex/actions.js